import './return-portal.scss';
import infoicon from "./../assets/images/icons/information.svg";
import React, { useState } from "react";
import { CUSTOMER_LOGIN } from "../constants";
import { useNavigate } from "react-router-dom";
import { Alert, FormControl, OutlinedInput, Snackbar } from '@mui/material';

function Loginportal(data1) {
  let data = data1.data;

  const [errorMessages, setErrorMessages] = useState({});
  const [isSendOtp, setIsSendOtp] = useState(false);
  const [authenticationId, setAuthentication] = useState('');
  const [email, setEmailValue] = useState('');
  const [orderNumber, setOrderNumber] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [otp, setOtpValue] = useState('');
  const isValidEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  const [emailValid, setEmailValid] = useState(false);
  const [tryWithOrderNumber, setTryWithOrderNumber] = useState(true)
  const [tryWithEmail, setTryWithEmail] = useState(false);
  const [snackOpen, setSnackOpen] = React.useState(false);
  const [zipcodenotvalid, setZipcodeNotValid] = useState(false);
  const [snackbarProp, setSnackbarProp] = useState({});

  let navigate = useNavigate();
  sessionStorage.removeItem('returnItemData');
  sessionStorage.removeItem('selectedReasonData');
  sessionStorage.removeItem('selectedDummyReasonData');
  sessionStorage.removeItem('isSelectedLineItems');
  sessionStorage.removeItem('RPI');
  sessionStorage.removeItem('email');

  const emailChange = (event) => {
    setEmailValue(event.target.value);
    if (event.target?.value && isValidEmail.test(event.target?.value)) {
      setEmailValid(true);
    } else {
      setEmailValid(false);
    }
    setErrorMessages({ name: "email", message: null });
  }

  const orderNumberInfo = (event) => {
    let value = event.target.value;
    setOrderNumber(value.replace(/\s/g, ''));
    setErrorMessages({ name: "orderNumber", message: null });
  }

  const zipcodeInfo = (event) => {
    const onlyNums = event.target.value.replace(/[^0-9]/g, '');
    let value = onlyNums;
    setZipcode(value.replace(/\s/g, ''));
    setErrorMessages({ name: "zipcode", message: null });
    if (value.length < 5 || value === '00000') {
      setZipcodeNotValid(false);
    }
    else {
      setZipcodeNotValid(true)
    }

  }

  const otpChange = (event) => {
    if (event.target.value[0] !== '-') {
      setOtpValue(event.target.value.replace(/[^a-zA-Z0-9-]/g, ''));
      setErrorMessages({ name: "otp", message: null });
    }
  };

  const otpKeyDown = (event) => {
    if (event.key === '-' && event.keyCode !== 8 ? otp.indexOf('-') > -1 : false) {
      event.preventDefault()
    }
  }

  const errors = {
    email: "Invalid Email",
    otp: "Invalid OTP",
  };

  const sendEmail = async (event) => {
    setOtpValue('');
    event.preventDefault();
    try {
      const response = await fetch(CUSTOMER_LOGIN.LOG_IN_URL, {
        method: 'POST',
        body: {},
        headers: {
          'Content-Type': 'application/json',
          'email_id': email,
          'X-Fenix-Store-Name': data.storeName
        }
      });

      const result = await response.json();
      if (response?.status === 200) {
        setIsSendOtp(true);
        setSnackOpen(true);
        setSnackbarProp({ style: 'success', msg: result?.message });
        setAuthentication(result.session_id);
      } else {
        setSnackOpen(true);
        setSnackbarProp({ style: 'error', msg: 'Failed to send the OTP to your email' });
        setErrorMessages({ name: "email", message: errors.email });
      }
    } catch (error) {
      setSnackOpen(true);
      setSnackbarProp({ style: 'error', msg: 'Network error' });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackOpen(false);
  };

  const handlesubmit = async (event) => {

    event.preventDefault();
    try {
      const response = await fetch(CUSTOMER_LOGIN.VALIDATE_OTP + '?X-Fenix-Session-ID=' + authenticationId + '&otp=' + otp, {
        method: 'POST',
        body: {},
        headers: {
          'Content-Type': 'application/json',
          'X-Fenix-Store-Name': data.storeName,
        }
      });

      if (response?.status === 200) {
        sessionStorage.setItem('email', JSON.stringify(email));
        sessionStorage.setItem('tenantId', JSON.stringify(data.tenantId));
        // let data2 = JSON.stringify(data.type);
        let data2 = '/my-orders'
        navigate(data2.replace(/"/g, ""));
      } else if (response?.status === 400) {
        const result = await response.json();
        result.description = result?.description === '[INVALID OTP PLEASE PROVIDE VALID OTP]' ? 'Invalid OTP. Please provide a valid OTP' : (result?.description === '[OTP ALREADY EXPIRED PLEASE RESEND OTP]' ? 'OTP has already expired. Please resend the OTP' : result?.description)
        // setSnackOpen(true);
        // setSnackbarProp({style:'error',msg:result?.description});
        setErrorMessages({ name: "otp", message: result?.description });
      }
    } catch (error) {
      setSnackOpen(true);
      setSnackbarProp({ style: 'error', msg: 'Network error.' });
    }
  };


  const sendOrderData = async (event) => {
    event.preventDefault();
    sessionStorage.setItem('tenantId', JSON.stringify(data.tenantId));
      let  orderInfo = {
           "orderNumber" : orderNumber,
           "zipcode": zipcode
      }
    sessionStorage.setItem('orderInfo',JSON.stringify(orderInfo))
    
    // let data2 = JSON.stringify(data.type);
    let data2 = '/my-orders';
    // navigate(data2.replace(/"/g, ""));
    navigate(
      {
        pathname: data2.replace(/"/g, ""),
        search: '?ordernumber=' + encodeURIComponent(orderNumber) + '&zipcode=' + zipcode,
      });
  }

  //  const anotherMail = () =>{
  //   setIsSendOtp(false);
  //   setEmailValue('');
  //  }

  const trywithemail = (event) => {
    event.preventDefault();
    setTryWithOrderNumber(false);
    setTryWithEmail(true);
    setZipcode("");
    setOrderNumber("");
    setIsSendOtp(false);
    setEmailValid(false);
  }

  const trywithorderNumber = (event) => {
    event.preventDefault();
    setTryWithEmail(false);
    setTryWithOrderNumber(true);
    setEmailValue("")
  }

  const renderErrorMessage = (name) =>
    name === errorMessages.name && (
      <span className="f-12 mt-5px error-color">{errorMessages.message}</span>
    );

  const renderForm = (
    <div className="container-fluid return-portal-wrapper px-0">
      <div className="row mx-0 align-items-center">
        <div className={`col-xl-6 rp-form-wrapper px-0 ${data.type}`}>
          <div className="rp-form-box">
            <h3 className="text-center fw-500">Return Portal</h3>
            {/* <p className="heading-subtext fw-500  text-center">Lorem ipsum dolor sit amet, consectetur aelit.</p> */}
            {tryWithOrderNumber ? <form className="rp-form-wrap">
              {/* <div className="form-controler input-container mb-10">
                    <input type="text" name="ordernumber" className="full-width p-10 br-5" value={orderNumber} onChange={orderNumberInfo} maxLength={16}  required/>
                    </div> */}
              <FormControl fullWidth sx={{ m: 1 }}>
                <div className="form-label required">Order Number</div>
                <OutlinedInput className={`form-control ${data.type}`} sx={{ '& ::placeholder': { fontSize: '12px' } }} placeholder={data.type === 'janieandjack' ? 'A0XXXXXXX or JJ0XXXXXX' : 'Enter order number'}
                  type="text" name="ordernumber" value={orderNumber} onChange={orderNumberInfo} inputProps={{ maxLength: 16 }} required
                  label="ordernumber" />
                {/* {renderErrorMessage("orderNumber")} */}
              </FormControl>
              <FormControl fullWidth sx={{ m: 1 }}>
                <div className="form-label required">Shipping Zip Code</div>
                <OutlinedInput type="text" name="zipcode" placeholder={data.type === 'janieandjack' ? 'xxxxx' : 'Ènter zip code'} sx={{ '& ::placeholder': { fontSize: '12px' } }} className={`form-control ${data.type}`} value={zipcode} onChange={zipcodeInfo} inputProps={{ maxLength: 5 }} required
                  label="zipcode" />
              </FormControl>
              {/* {renderErrorMessage("orderNumber")} */}
              {/* <div className="form-controler input-container mb-10">
                    <input type="text" name="zipcode" className="full-width p-10 br-5" value={zipcode} onChange={zipcodeInfo} maxLength={10} required/>
                    {renderErrorMessage("zipcode")}
                  </div> */}
              <div className="form-btn-wrap">
                <button onClick={sendOrderData} disabled={!orderNumber || !zipcode || !zipcodenotvalid} className={`btn-primary w-100 ${data?.type ? data.type + '-btn' : ''} ${(!orderNumber || !zipcode || !zipcodenotvalid) ? 'cursor-not-allowed op-5' : 'cursor-pointer'}`}>Get order</button>
              </div>
            </form>:
              <div>
                <p className="heading-subtext fw-500 text-center">{!isSendOtp ? 'You will receive an email with verification code.' : 'Enter the verification code sent to your email'}</p>
                {!isSendOtp ?
                  <form className='rp-form-wrap'>
                    {/* <div className="form-controler input-container mt-10 mb-20">
                    <input type="email" name="email" className="full-width p-10 br-5" autoComplete='' value={email} onChange={emailChange} required/>
                  </div> */}
                    <FormControl fullWidth sx={{ m: 1 }}>
                      <div className="form-label required">Email Id</div>
                      <OutlinedInput className={`form-control ${data.type}`} sx={{ '& ::placeholder': { fontSize: '12px' } }} type="email" name="email" placeholder="Enter email" value={email} onChange={emailChange} required
                        label="email" />
                      {renderErrorMessage("email")}
                    </FormControl>
                    <div className="form-btn-wrap">
                      <button onClick={sendEmail} disabled={!emailValid} className={`btn-primary w-100 ${data?.type ? data.type + '-btn' : ''} ${(!emailValid) ? 'cursor-not-allowed op-5' : 'cursor-pointer'}`}>Send One-Time Password</button>
                    </div>
                  </form>:
                  <div>
                    <form className='rp-form-wrap'>
                      {/* <div className="form-controler input-container mt-10 mb-16">
                      <input type="text" className="full-width p-16 br-10" value={otp} onChange={otpChange} />
                    </div> */}
                      <FormControl fullWidth sx={{ m: 1 }}>
                        <div className="form-label required">Enter OTP</div>
                        <OutlinedInput className={`form-control ${data.type}`} type="text" sx={{ '& ::placeholder': { fontSize: '12px' } }} placeholder='Enter One-Time Password' name="otp" value={otp}
                          onKeyDown={otpKeyDown} onChange={otpChange} inputProps={{ maxLength: 10 }} required label="otp" />
                        {renderErrorMessage("otp")}
                      </FormControl>
                      <div className="receive-code text-center">
                        <span>Didn’t receive a code?</span> <span className='cursor-pointer fw-500' onClick={sendEmail}>Resend</span>
                      </div>
                      <div className="form-btn-wrap">
                        <button onClick={handlesubmit} disabled={!otp} className={`btn-primary w-100 ${data?.type ? data.type + '-btn' : ''} `}>Verify</button>
                      </div>
                    </form>
                    {/* <div className="text-center mt-10">
                   <a href='login' onClick={anotherMail} className="primary-color fw-500">Try with another email</a>
              </div> */}
                  </div>}
              </div>
            }
            {tryWithOrderNumber === true ?
              <div className='login-with-alt-opt'>
                <div className='or-line'></div>
                <a href="/" className="btn-primary-border w-100 cursor-pointer d-block text-center" onClick={trywithemail} >Login with email</a>
              </div> : ""
            }
            {tryWithEmail === true ? <div className='login-with-alt-opt'>
              <div className='or-line'></div>
              <a href="/" className="btn-primary-border w-100 cursor-pointer d-block text-center" onClick={trywithorderNumber} >Login with order number</a>
            </div> : ""}

            <div className="text-center rpolicy-link-wrap">
              <img src={infoicon} className="pinfoicon" alt="fenixcommerce" />
              <a href={JSON.parse(sessionStorage.getItem('config-data'))?.return_policy_url ? JSON.parse(sessionStorage.getItem('config-data'))?.return_policy_url : data?.policyUrl} target='_blank' className="rpolicy-link fw-500 cursor-pointer"
                rel="noopener noreferrer">Return Policy</a>
            </div>
          </div>
        </div>
        <div className="col-xl-6 rp-img-wrap px-0">
          <img className="rp-right-img w-100" src={require(`../assets/images/${data.login_img}`)} alt='ParcelDelivery' />
        </div>
      </div>
    </div>
  );
  return (
    <div>
      {renderForm}
      <Snackbar
        open={snackOpen}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "center"
        }}
      >
        <Alert
          onClose={handleClose}
          severity={snackbarProp.style}
          variant="filled"
          sx={{ width: '100%' }}
        >{snackbarProp.msg}
        </Alert></Snackbar>
    </div>

  );
}

export default Loginportal;